import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-svg-loader',
  templateUrl: './svg-loader.component.html',
  imports: [CommonModule],
  styleUrl: './svg-loader.component.scss',
  standalone: true,
})
export class SvgLoaderComponent implements OnInit {
  @Input() url: string;
  @Input() height: string = "24px";
  svgContent: string = '';
  sanitizedSvgContent: SafeHtml = '';

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}
  ngOnInit() {
    if (this.url) {
      this.loadSvg(this.url);
    }
  }

  loadSvg(filePath: string) {
    const uniqueSuffix = `-${Math.random().toString(36).substring(2, 8)}`;
    const cleanPath = filePath.split('?')[0];
  
    this.http.get(cleanPath, { responseType: 'text' }).subscribe(
      (data) => {
        // Replace all id="something" with id="something-abc123"
        let updatedSvg = data.replace(/id="([^"]+)"/g, (_, id) => `id="${id}${uniqueSuffix}"`);
  
        // Also update all references to those IDs, e.g. url(#something), href="#something"
        updatedSvg = updatedSvg
          .replace(/url\(#([^"]+)\)/g, (_, id) => `url(#${id}${uniqueSuffix})`)
          .replace(/xlink:href="#([^"]+)"/g, (_, id) => `xlink:href="#${id}${uniqueSuffix}"`)
          .replace(/href="#([^"]+)"/g, (_, id) => `href="#${id}${uniqueSuffix}"`);
  
        this.sanitizedSvgContent = this.sanitizer.bypassSecurityTrustHtml(updatedSvg);
      },
      (error) => console.error('Error loading SVG:', error)
    );
  }
  
}